import { useQuery } from "@tanstack/react-query";
import {
  getAllHallOfFameCategories,
  getAllPaidAwardCertificates,
  getHallOfFamePicture,
  getHallOfFameStudents,
} from "../query/hall-of-fame";

// Fetch all hall of fame categories
export const useHallOfFameCategories = () => {
  return useQuery({
    queryKey: ["hallOfFameCategories"],
    queryFn: getAllHallOfFameCategories,
    staleTime: 1000 * 60 * 5,
  });
};

// Fetch students for a specific hall of fame by ID
export const useHallOfFameStudents = (hallOfFameId: number | null) => {
  return useQuery({
    queryKey: ["hallOfFameStudents", hallOfFameId],
    queryFn: () => getHallOfFameStudents(hallOfFameId!),
    enabled: hallOfFameId !== null,
    staleTime: 1000 * 60 * 5,
  });
};

// Legacy hook — keeps backward compat with existing code
export const useHallOfFame = (limit?: number) => {
  return useQuery({
    queryKey: ["hallOfFame", limit],
    queryFn: async () => {
      const certificates = await getAllPaidAwardCertificates();
      if (limit) return certificates.slice(0, limit);
      return certificates;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useHallOfFamePicture = (hallOfFameId: number) => {
  return useQuery({
    queryKey: ["hallOfFamePicture", hallOfFameId],
    queryFn: () => getHallOfFamePicture(hallOfFameId),
    staleTime: 1000 * 60 * 5,
  });
};
